import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import authReducer from "../reducers/authReducer";
import fetchReducer from "../reducers/fetchReducer";
import ImageReducer from "../reducers/ImageReducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      auth: authReducer,
      fetch: fetchReducer,
      image: ImageReducer,
    }),
    composeEnhancers(applyMiddleware(thunk))
  );

  return store;
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js